import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import { Footer } from './components/Footer';
import Home from './pages/Home';
import Team from './pages/Team';
import TeamAdmin from './pages/TeamAdmin';
import BikePark from './pages/BikePark';
import Map from './pages/Map';
import ReportProblem from './pages/ReportProblem';
import MiniExpress from './pages/MiniExpress';
// import Potecarul from './pages/Potecarul';
import { LoginForm } from './components/Auth/LoginForm';
import { ProtectedRoute } from './components/Auth/ProtectedRoute';

function App() {
  const location = useLocation();
  const hideFooter = location.pathname === '/donatii';

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/team" element={<Team />} />
          <Route path="/login" element={<LoginForm />} />
          <Route 
            path="/team-admin" 
            element={
              <ProtectedRoute>
                <TeamAdmin />
              </ProtectedRoute>
            } 
          />
          <Route path="/bikepark" element={<BikePark />} />
          <Route path="/harta" element={<Map />} />
          <Route path="/report" element={<ReportProblem />} />
          <Route path="/donatii" element={<MiniExpress />} />
          {/* <Route path="/potecarul" element={<Potecarul />} /> */}
          {/* Catch-all route - redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      {!hideFooter && <Footer />}
    </div>
  );
}

export default App;